var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"timer"},[_vm._v(" Time left: "),_c('span',{staticClass:"countdown"},[_vm._v(_vm._s(_vm.timeLeft))])])}
var staticRenderFns = []

export { render, staticRenderFns }